export default "__VITE_ASSET__DWcFmnEq__"